import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-msg-preview-dialog',
  templateUrl: './msg-preview-dialog.component.html',
  styleUrls: ['./msg-preview-dialog.component.css']
})
export class MsgPreviewDialogComponent implements OnInit {

  blob: Blob;
  fileName: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) data,
    private _dialogRef: MatDialogRef<MsgPreviewDialogComponent>
  ) {
    this.blob = data.blob;
    this.fileName = data.fileName;
  }

  close = () => this._dialogRef.close();

  ngOnInit(): void {
  }

}
